import React, { createContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, Container } from "@mui/material";
import QMentisBreadCrumb from "../custom-components/QMentisBreadCrumb";

export const TestCaseFlowDataContext = createContext(null);
export const TestCaseLoaderStateContext = createContext(null);

const TestcaseGenerationPage = () => {
  const [userStory, setUserStory] = useState({});
  const [functionalSpecDocument, setFunctionalSpecDocument] = useState({});
  const [useCase, setUseCase] = useState({});
  const [testcases, setTestCases] = useState([]);
  const [testConditions, setTestConditions] = useState({});
  const [testTechniques, setTestTechniques] = useState({});
  const [traceabilityMatrix, setTraceabilityMatrix] = useState({});
  const [selectedTestingTypes, setSelectedTestingTypes] = useState([]);
  const [testCaseLoaderState, setTestCaseLoaderState] = useState(null);

  const breadCrumbs = [
    {
      title: "Input Details",
      status:
        (typeof userStory === "string" && userStory.trim().length > 0) || Object.keys(functionalSpecDocument || {}).length > 0
          ? "Completed"
          : "In Progress",
    },
    {
      title: "Generate FSD",
      status:
        Object.keys(functionalSpecDocument || {}).length > 0
          ? "Completed"
          : Object.keys(functionalSpecDocument || {}).length > 0 &&
            testCaseLoaderState === "Functional Specification Document"
            ? "In Progress"
            : "Not Started",
    },
    {
      title: "Generate Use Cases",
      status:
        Object.keys(useCase || {}).length > 0
          ? "Completed"
          : Object.keys(userStory || {}).length > 0 &&
            testCaseLoaderState === "Use Case"
            ? "In Progress"
            : "Not Started",
    },
    {
      title: "Generate Test Conditions",
      status:
        Object.keys(testConditions || {}).length > 0
          ? "Completed"
          : Object.keys(testConditions || {}).length > 0 &&
            testCaseLoaderState === "Test Conditions"
            ? "In Progress"
            : "Not Started",
    },
    {
      title: "Generate Test Techniques",
      status:
        Object.keys(testTechniques || {}).length > 0
          ? "Completed"
          : Object.keys(testTechniques || {}).length > 0 &&
            testCaseLoaderState === "Test Techniques"
            ? "In Progress"
            : "Not Started",
    },
    {
      title: "Select Testing Types",
      status:
      (selectedTestingTypes || []).length > 0
          ? "Completed"
          : Object.keys(useCase || {}).length > 0 && testCaseLoaderState === "Select Testing Types"
            ? "In Progress"
            : "Not Started",
    },
    {
      title: "Generate Test Cases",
      status:
        (testcases || []).length > 0
          ? "Completed"
          : Object.keys(useCase || {}).length > 0 &&
            testCaseLoaderState === "Test Cases"
            ? "In Progress"
            : "Not Started",
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "centre",
        flexGrow: 1,
      }}
    >
      <Box sx={{ maxHeight: "100%", width: "100%" }}>
        <Box
          sx={{
            position: "sticky",
            top: "0", 
            width: "100%",
            zIndex: 1000, 
            bgcolor: "white", 
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", 
          }}
        >
          <QMentisBreadCrumb
            breadCrumbs={breadCrumbs}
            sx={{ height: "56px" }}
          />
        </Box>

        <Container
          sx={{
            width: "100%",
          }}
        >
          <TestCaseLoaderStateContext.Provider
            value={{ testCaseLoaderState, setTestCaseLoaderState }}
          >
            <TestCaseFlowDataContext.Provider
              value={{
                userStory,
                setUserStory,
                functionalSpecDocument,
                setFunctionalSpecDocument,
                useCase,
                setUseCase,
                testcases,
                setTestCases,
                testConditions,
                setTestConditions,
                testTechniques,
                setTestTechniques,
                traceabilityMatrix,
                setTraceabilityMatrix,
                selectedTestingTypes,
                setSelectedTestingTypes,
              }}
            >
              <Outlet />
            </TestCaseFlowDataContext.Provider>
          </TestCaseLoaderStateContext.Provider>
        </Container>
      </Box>
    </Box>
  );
};

export default TestcaseGenerationPage;
